<template>
	<div class="activity-record-table">
		<Commontable :tableData="tableData" :headerData="headerData" :hasChecked="false" @onRowClick="onRowClick"
			@handleSelectionChange="handleSelectionChange"></Commontable>
	</div>
</template>

<script>
	import Commontable from "@/components/common-table.vue";

	export default {
		components: {
			Commontable
		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				headerData: [{
						prop: 'selection',
						types: 'selection',
						fixed: 'left'
					},
					{
						prop: 'StatusName',
						label: '状态',
						columnwidth: 100
					},
					{
						prop: 'ActivityName',
						label: '活动名称',
						columnwidth: 150
					},
					{
						prop: 'LEVEL2',
						label: '会议类型（L2）',
						columnwidth: 150
					},
					{
						prop: 'LEVEL3',
						label: '重点产品（L3）',
						columnwidth: 200
					},
					{
						prop: 'PreConductDate',
						label: '举办时间',
						columnwidth: 180
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 100
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 120
					},
					{
						prop: 'ActivityCode',
						label: '活动编号',
						columnwidth: 150
					}
				]
			};
		},
		methods: {
			onRowClick(row) {
				this.$emit('onRowClick', row);
			},
			handleSelectionChange(val) {
				console.log(val);
				this.$emit('selectionChange', val);
			}
		}
	};
</script>

<style scoped>
	.activity-record-table {
		width: 100%;
	}
</style>